import React from 'react';
import { Text } from '@fragments';
import './styles.scss';

// A centered state in a page or a block: signed out, nothing yet, nothing found, a failed read.
export default function PageState({ icon, title, text, action, children, compact = false }) {
  return <div className={`studio-automations-state${compact ? ' is-compact' : ''}`}>
    {icon && <span className="studio-automations-state__icon" aria-hidden="true">{icon}</span>}
    {title && <Text.h5 weight={500} contrast={9}>{title}</Text.h5>}
    {text && <Text.p contrast={7}>{text}</Text.p>}
    {children}
    {action}
  </div>;
}
